<template>
    <button
        type="button"
        class="button button--submit"
        :class="[
            defaultLook ? '' : 'button--wider skip-step-button button--skip',
        ]"
        @click.prevent="navigateStep"
    >
        {{ text }}
        <slot />
    </button>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { ResponseStatus } from '@/constants/ajax';

export default defineComponent({
    name: 'NavigateButton',
    props: {
        pathName: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        defaultLook: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const store = useStore();
        const defaultStep = ref('mobileReturnToDesktop');

        const navigateStep = async () => {
            const params = new URLSearchParams(window.location.search);
            if (
                (params.has('mobile') || params.has('qrCode')) &&
                !checkWindowPathName()
            ) {
                const ajaxService = store.state.ajaxService;
                const data = await ajaxService.post(
                    ajaxService.PROXY_ROUTE + 'form-pl/skip-hybrid-upload',
                    {
                        token: ajaxService.getToken(),
                    }
                );
                if (ResponseStatus.SUCCESS === data.status) {
                    await store.state.navigationService.goToRoute(
                        defaultStep.value
                    );
                } else {
                    newError();
                }
                emit('click');
            } else {
                emit('click');
                await store.state.navigationService.goToRoute(props.pathName);
            }
        };

        const checkWindowPathName = () => {
            return window.location.pathname.indexOf('document-selection') > -1;
        };

        const newError = () => {
            // todo: proper error handling
            console.error('AN UNEXPECTED ERROR HAS BEEN TAKEN');
        };

        return {
            defaultStep,
            navigateStep,
            checkWindowPathName,
            newError,
        };
    },
});
</script>
